export default __webpack_public_path__ + "static/media/012-shocked.74ae11a4.svg";